import { DataTableDesignTokens } from '@primeuix/themes/types/datatable'

const index: DataTableDesignTokens = {
  colorScheme: {
    light: {
      headerCell: {
        hoverBackground: '{surface.50}',
        selectedBackground: '{surface.50}'
      }
    }
  }
}

export { index as default }
